import * as React from "react";
import videojs from "video.js";
import { useForm, FormContextInterface } from "../context";

// Styles
import "video.js/dist/video-js.css";

interface IVideoPlayerProps {
  options?: any;
}

const initialOptions: any = {
  controls: true,
  fluid: true,
  controlBar: {
    volumePanel: {
      inline: false
    }
  }
};

const VideoPlayer: React.FC<IVideoPlayerProps> = ({ options = {} }) => {
  const { handleSubmitLogActivity } = useForm() as FormContextInterface;
  const videoNode = React.useRef<HTMLVideoElement>(null);
  const player = React.useRef<any>();

  const videoClick = () => {
    const playbtn = document.getElementsByClassName("vjs-paused")
    const pausedbtn = document.getElementsByClassName("vjs-playing")
    const videoBtn = document.getElementsByClassName("vjs-big-play-button");
    const videoPoster = document.getElementsByClassName("vjs-poster");

    if (playbtn[0]) {
      handleSubmitLogActivity({
        ActivityType: "VideoPlayButton"
      })
    }
    else if (pausedbtn[0]) {
      handleSubmitLogActivity({
        ActivityType: "VideoPauseButton"
      })
    }
    else if (videoBtn[0]) {
      handleSubmitLogActivity({
        ActivityType: "VideoPlayButton"
      })
    }
    else if (videoPoster[0]) {
      handleSubmitLogActivity({
        ActivityType: "VideoClick"
      })
    }
  }

  React.useEffect(() => {
    if (videoNode.current) {
      player.current = videojs(videoNode.current, {
        ...initialOptions,
        ...options
      }).ready(function () {
      });

      // get video Play Button 
      const videoBtn = document.getElementsByClassName("vjs-big-play-button");
      videoBtn[0].addEventListener("click", videoClick);

      // get poster 
      const videoPoster = document.getElementsByClassName("vjs-poster");
      videoPoster[0].addEventListener("click", videoClick);

      // get play button
      const playbtn = document.getElementsByClassName("vjs-play-control")
      playbtn[0].addEventListener("click", videoClick);

      // get video
      const schoolVideo = document.getElementById("vjs_video_3_html5_api")
      schoolVideo?.addEventListener("click", videoClick)
    }
    return () => {
      if (player.current) {
        player.current.dispose();
      }
    };
  }, []);

  return <video ref={videoNode} className="video-js vjs-default-skin vjs-big-play-centered vjs-fluid vjs-nofull" />;
};

export default VideoPlayer;
